module.exports = __webpack_public_path__ + "static/img/pad9.97c4cf9e.png";